module.exports = __webpack_public_path__ + "img/coupon1.b3dd9e53.png";